import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NavigationItem } from '../types';
import { PERMISSIONS } from '../../../../constants/permissionsConstants';

export interface NavigationState {
  navigationItems: NavigationItem[];
  isEmbedded: boolean;
  powerUnitNumber: string;
}

const navigationInitialState: NavigationState = {
  navigationItems: [
    {
      header: 'Hours of Service Logs',
      description: 'Certify up to six months of HOS logs',
      linkTo: '/hos-logs',
    },
    {
      header: 'Messages',
      description: '',
      linkTo: '/messages',
      permissions: [PERMISSIONS.APP_MESSAGES_ACCESS],
      mobileOnly: false,
    },
    {
      header: 'Unclaimed Movements',
      description: '',
      linkTo: '/movements',
      mobileOnly: true,
    },
  ],
  isEmbedded: false,
  powerUnitNumber: '',
};

interface SetNavigationItemsPayload {
  navigationItems: NavigationItem[];
}

interface SetIsEmbeddedPayload {
  isEmbedded: boolean;
}

export const reducerSlice = createSlice({
  name: 'navigationReducer',
  initialState: navigationInitialState,
  reducers: {
    setNavigationItems: (state, action: PayloadAction<SetNavigationItemsPayload>): void => {
      state.navigationItems = action.payload.navigationItems;
    },
    setIsEmbedded: (state, action: PayloadAction<SetIsEmbeddedPayload>): void => {
      state.isEmbedded = action.payload.isEmbedded;
      // Persisting the embedded query param so it remains available after refresh
      localStorage.setItem('isEmbedded', String(action.payload.isEmbedded));
    },
    setPowerUnitNumber: (state, action: PayloadAction<string>): void => {
      state.powerUnitNumber = action.payload;
      localStorage.setItem('powerUnitNumber', action.payload);
    },
  },
});

export const { setNavigationItems, setIsEmbedded, setPowerUnitNumber } = reducerSlice.actions;

export default reducerSlice.reducer;
